import React from "react";
import Mainlayout from "components/app-layout";
import AuthProvider from "context/auth";
import ConfigUserProvider from "context/config";
import NotificationProvider from "context/notification";
import AuthNotificationProvider from "context/notification/auth-notification";

//algorithm: theme.darkAlgorithm,
const App = () => {
    return (
        <AuthNotificationProvider>
            <AuthProvider>
                <ConfigUserProvider>
                    <NotificationProvider>
                        <Mainlayout></Mainlayout>
                    </NotificationProvider>
                </ConfigUserProvider>
            </AuthProvider>
        </AuthNotificationProvider>
    );
};

export default App;
